import { useMutation } from '@hooks/reactQuery';

import { getConfigurationTemplateValidationRules } from '@api/configurationTemplates';

import { EValidationRuleType, getTreeNodeValidation } from '@utils/treeValidation';

import { TConfigurationTemplateValidationDTO } from '@interfaces/cmModule/dto/configurationTemplatesDTO';
import { ITreeValidationDTO } from '@interfaces/cmModule/dto/goldenSettingsDTO';
import { IFlatTreeValidationRule, TFlatTreeGetValidation } from '@components/common/FlatTree/interface';

import { EUserRoles } from '@enums/common';

import { GOLDEN_SETTING_VALIDATION_RULES } from '@constants/queryKeys';

interface IUseMutateConfigurationTemplateValidationRulesReturnType {
	validationRulesData: IFlatTreeValidationRule[];
	getValidationRules: TFlatTreeGetValidation;
	isLoadingValidationRules: boolean;
}

const useMutateConfigurationTemplateValidationRules = (
	validationRulesFolderId?: string,
): IUseMutateConfigurationTemplateValidationRulesReturnType => {
	const {
		data,
		isLoading,
		mutateAsync: getValidationRules,
	} = useMutation<TConfigurationTemplateValidationDTO>({
		mutationKey: [GOLDEN_SETTING_VALIDATION_RULES],
		mutationFn: async ({ nameSpace, name, path }: ITreeValidationDTO) => {
			if (name && nameSpace && validationRulesFolderId) {
				const data: IFlatTreeValidationRule[] = await getConfigurationTemplateValidationRules({
					name,
					nameSpace,
					path: path.replace(new RegExp(`/${name}$`), ''),
					validationRulesFolderId: validationRulesFolderId,
				});

				return {
					rules: data,
					validations: getTreeNodeValidation(
						data.filter((item) => item.type.name !== EValidationRuleType.MANDATORY),
						!data.length,
					),
				};
			}
		},
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
	});

	return {
		validationRulesData: data || [],
		getValidationRules: getValidationRules,
		isLoadingValidationRules: isLoading,
	};
};

export default useMutateConfigurationTemplateValidationRules;
